module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("96KMa"))).then(() => module.bundle.root('aVi2q'));